import React from 'react';
import './ReviewSection.css'; // You'll need to create this CSS file

const ReviewSection = () => {
  // Sample review data (you can replace this with dynamic data from an API)
  const reviews = [
    {
      id: 1,
      name: "Sarah Johnson",
      date: "February 15, 2025",
      rating: 5,
      text: "Absolutely amazing experience! The rooms were spotless and the staff was incredibly friendly. Highly recommend staying here."
    },
    {
      id: 2,
      name: "Michael Chen",
      date: "February 10, 2025",
      rating: 4,
      text: "Great location and comfortable beds. The only minor issue was the slow Wi-Fi, but everything else was perfect."
    },
    {
      id: 3,
      name: "Emily Rodriguez",
      date: "February 5, 2025",
      rating: 5,
      text: "Beautiful property with stunning views. The breakfast buffet was delicious and the service was top-notch!"
    }
  ];

  return (
    <div className="review-section">
        {/*  */}
        <div className="property-rules-container">
      <h2 className="rules-title">Property Rules</h2>
      
      <div className="check-times">
        <span>Check-in: 2 PM</span>
        <span>Check-out: 12 PM</span>
      </div>

      <div className="rules-content">
        <div className="rules-column">
          <h3 className="rules-subtitle">Couple, Bachelor Rules</h3>
          <p className="couple-friendly">COUPLE FRIENDLY</p>
          <ul className="rules-list">
            <li>Unmarried couples/guests with Local IDs are allowed.</li>
            <li>Passport, Aadhar and Driving License are accepted as ID proof(s)</li>
            <li>Pets are not allowed</li>
            <li>Outside food is not allowed</li>
            <li>Smoking within the premises is not allowed</li>
          </ul>
        </div>

        <div className="rules-column">
          <ul className="additional-rules">
            <li>Optional: Fee for buffet breakfast: approximately INR 500 for adults and INR 500 for children/Rollaway bed fee: INR 1500 per night</li>
            <li>Extra-person charges may apply and vary depending on property policy/Government-issued photo identification and a credit card, debit card, or cash deposit may be required at check-in for incidental charges/Special requests are subject to availability upon check-in and may incur additional charges; special requests cannot be guaranteed</li>
            <li>This property accepts credit cards/Safety features at this property include a fire extinguisher, a security system, a first aid kit, and window guards</li>
          </ul>
        </div>
      </div>

      <div className="rules-actions">
        <button className="action-button">Must Read Rules</button>
        <button className="action-button">Guest Profile</button>
        <button className="action-button">ID Proof Related</button>
        <a href className="read-all-link">Read All Property Rules</a>
      </div>
    </div>
        {/*  */}
      <h2 className="review-title">Customer Reviews</h2>
      <div className="reviews-container">
        {reviews.map(review => (
          <div key={review.id} className="review-card">
            <div className="review-header">
              <span className="reviewer-name">{review.name}</span>
              <span className="review-date">{review.date}</span>
            </div>
            <div className="review-rating">
              {[...Array(5)].map((_, index) => (
                <span 
                  key={index} 
                  className={`star ${index < review.rating ? 'filled' : ''}`}
                >
                  ★
                </span>
              ))}
            </div>
            <p className="review-text">{review.text}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ReviewSection;